// extracted by mini-css-extract-plugin
export default {"container":"ProgressButtons_container__eFtvP","left-arrow":"ProgressButtons_left-arrow__w7Vwp"};